"use client";

import { VenuePageEvents, trackEvent } from "@punchup/analytics";
import { VenuePageUrlBase, getBasePath } from "./navigation/utils";

import Image from "next/image";
import Link from "next/link";
import VenuePageHamburgerMenu from "./navigation/VenuePageHamburgerMenu";
import { VenuePagesRow } from "../../data/venue_pages";
import { getCDNImageURL } from "@punchup/utils/getCDNImageURL";
import { useVenuePageTheme } from "@punchup/venues";

interface Props {
  venuePage: VenuePagesRow;
  urlBase?: VenuePageUrlBase;
}

export default function VenuePageHeader({ venuePage, urlBase = "/v/" }: Props) {
  const { name, slug, logo_img } = venuePage;

  const { headerBackgroundColor, headerBorderColor } = useVenuePageTheme(slug);

  const imgUrl = logo_img ? getCDNImageURL(logo_img) : null;

  const handleHamburgerMenuClick = () => {
    trackEvent(VenuePageEvents.HEADER_HAMBURGER_MENU_BUTTON_CLICKED);
  };

  const homeHref = getBasePath(urlBase, slug, { trailingSlash: true });

  return (
    <header
      className="h-header-bar fixed top-app-banner left-0 right-0 w-full z-50 filter drop-shadow-nav border-b transition-all duration-200 ease-in-out-cubic border-neutral-200"
      style={{
        borderColor: headerBorderColor,
        backgroundColor: headerBackgroundColor,
      }}
    >
      <div className="flex flex-row items-center justify-between w-full h-full px-3 md:px-4">
        <Link
          href={homeHref}
          className="flex flex-row items-center justify-start object-contain h-full"
          style={{ width: "auto" }}
        >
          {imgUrl ? (
            <Image
              src={imgUrl}
              alt={`${name} logo`}
              height={50}
              width={50}
              sizes="50px"
              style={{
                width: "auto",
              }}
              className="object-contain h-[32px] md:h-[46px]"
              priority
            />
          ) : (
            <span>{name}</span>
          )}
        </Link>
        <div className="flex flex-row items-center object-contain h-full gap-1 md:gap-2">
          <VenuePageHamburgerMenu
            onClick={handleHamburgerMenuClick}
            venuePage={venuePage}
            urlBase={urlBase}
          />
        </div>
      </div>
    </header>
  );
}
